export const SET_ACTIVE_TAB = 'SET_ACTIVE_TAB';
export const SET_IS_SIDENAV_OPEN = 'SET_IS_SIDENAV_OPEN';

const initState = {
  isSideNavOpen: localStorage.getItem('IS_SIDENAV_OPEN') ? JSON.parse(localStorage.getItem('IS_SIDENAV_OPEN')) : false,
  activeTab: localStorage.getItem('partnerhub-active-tab')
    ? localStorage.getItem('partnerhub-active-tab')
    : 'Warehouse',
};

export default function reducer(state = initState, action) {
  switch (action.type) {
    case SET_ACTIVE_TAB:
      return {
        ...state,
        activeTab: action.payload,
      };
    case SET_IS_SIDENAV_OPEN:
      return {
        ...state,
        isSideNavOpen: action.payload,
      };
    default:
      return state;
  }
}
